<template>
  <div v-if="isMakeForm" :class="['he-item', {'he-item__active': data.makeStyle.active}]">
    <div v-if="showMask" class="he-item--mask" />
    <div v-show="data.makeStyle.active" class="he-item--op">
      <span class="he-item--op--copy" @click.stop="copy"><i class="el-icon-document-copy" /></span>
      <span class="he-item--op--delete" @click.stop="del"><i class="el-icon-delete" /></span>
    </div>
    <el-form-item :label="formData.formStyle.hideLabel || data.style.hideLabel ? '' : data.label" :label-width="formData.formStyle.hideLabel || data.style.hideLabel ? '0' : ''" :class="{'required': required && formData.formStyle.showRequiredAsterisk}">
      <slot />
    </el-form-item>
  </div>
  <el-form-item v-else :label="formData.formStyle.hideLabel || data.style.hideLabel ? '' : data.label" :label-width="formData.formStyle.hideLabel || data.style.hideLabel ? '0' : ''" :prop="prop" :class="{'required': required && formData.formStyle.showRequiredAsterisk}">
    <slot />
  </el-form-item>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'ItemBox',
  inject: {
    formData: {
      default: () => {}
    },
    contentSelectChange: {
      default: () => () => {}
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    isMakeForm: {
      type: Boolean,
      default: true
    },
    prop: {
      type: String,
      default: ''
    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    required() {
      return Reflect.has(this.data, 'rules') && Reflect.has(this.data.rules, 'required')
    }
  },
  methods: {
    copy() {
      const data = _.cloneDeep(this.data)
      data.fieldId = `${data.name}_${new Date().getTime()}`
      data.makeStyle.active = false
      const i = this.formData.formDataList.findIndex(li => li.fieldId === this.data.fieldId)
      if (i > -1) this.formData.formDataList.splice(i + 1, 0, data)
      else {
        const allColList = this.formData.formDataList.filter(li => li.name === 'Layout')
        for (let x = 0; x < allColList.length; x++) {
          const j = allColList[x].setting.colList.findIndex(c => c.fieldId === this.data.fieldId)
          if (j > -1) allColList[x].setting.colList.splice(j + 1, 0, data)
        }
      }
      this.$emit('copy', this.data)
    },
    del() {
      const i = this.formData.formDataList.findIndex(li => li && li.fieldId === this.data.fieldId)
      if (i > -1) this.formData.formDataList.splice(i, 1)
      else {
        const allColList = this.formData.formDataList.filter(li => li.name === 'Layout')
        for (let x = 0; x < allColList.length; x++) {
          const j = allColList[x].setting.colList.findIndex(c => c && c.fieldId === this.data.fieldId)
          if (j > -1) allColList[x].setting.colList.splice(j, 1)
        }
      }
      this.$emit('delete', this.data)
      typeof this.contentSelectChange === 'function' && this.contentSelectChange(null)
    }
  }
}
</script>
<style lang="scss">
@import '../../index.scss';
.he-item {
  position: relative;
  width: 100%;
  min-height: $mf-item-height;
  box-sizing: border-box;
  padding: 3px 10px;
  @include display-flex(column, nowrap, center, center);
  border: 1px solid transparent;
  &:hover {
    border-color: $primary-color;
    .he-item--op--delete, .he-item--op--copy {
      visibility: visible;
    }
  }
  &__active {
    border-color: $warning-color;
    .he-item--op--delete, .he-item--op--copy {
      visibility: visible;
      background-color: $warning-color;
    }
    &:hover {
      border-color: $warning-color;
    }
  }
  &--mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 888;
  }
  &--op {
    position: absolute;
    width: 100%;
    z-index: 999;
    bottom: 0;
    left: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;

    &--delete, &--copy {
      visibility: hidden;
      padding: 4px 8px;
      background-color: $primary-color;
      margin-left: 1px;
      cursor: pointer;
      i {
        color: white;
      }
    }
  }

  & .required {
    .el-form-item__label::before{
      content: '*';
      color: $error-color;
      margin-right: 4px;
    }
  }
}

</style>
